// src/utils/formatNumber.ts - Format large numbers for display
export function formatNumber(num: number | null | undefined): string {
	const value = typeof num === 'number' && Number.isFinite(num) ? num : 0;
	if (value >= 1000000) {
		return (value / 1000000).toFixed(1) + 'M';
	} else if (value >= 1000) {
		return (value / 1000).toFixed(1) + 'K';
	}
	return value.toString();
}
